<template>
  <div class="login-container">
    <!-- 3D打印主题背景 -->
    <div class="background-container">
      <!-- 动态背景SVG -->
      <svg class="background-svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="bg-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#0f1419" />
            <stop offset="30%" stop-color="#1a2332" />
            <stop offset="70%" stop-color="#2d3748" />
            <stop offset="100%" stop-color="#1a202c" />
          </linearGradient>
          <linearGradient id="printer-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#4fc3f7" />
            <stop offset="100%" stop-color="#29b6f6" />
          </linearGradient>
          <linearGradient id="blueprint-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#00bcd4" />
            <stop offset="100%" stop-color="#0097a7" />
          </linearGradient>
          <radialGradient id="radial-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="rgba(79,195,247,0.15)" />
            <stop offset="100%" stop-color="rgba(79,195,247,0)" />
          </radialGradient>
          <pattern id="blueprint-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <rect width="20" height="20" fill="none" />
            <path d="M 20,0 L 0,0 0,20" fill="none" stroke="rgba(0,188,212,0.1)" stroke-width="0.5"/>
          </pattern>
          <filter id="glow">
            <feGaussianBlur stdDeviation="0.5" result="coloredBlur"/>
            <feMerge> 
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
          <filter id="blueprint-glow">
            <feGaussianBlur stdDeviation="0.8" result="coloredBlur"/>
            <feMerge> 
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        <!-- 背景渐变 -->
        <rect width="100%" height="100%" fill="url(#bg-gradient)" />
        
        <!-- 蓝图网格背景 -->
        <rect width="100%" height="100%" fill="url(#blueprint-pattern)" opacity="0.3" />
        
        <!-- 径向光晕效果 -->
        <circle cx="20%" cy="30%" r="30%" fill="url(#radial-glow)" opacity="0.6">
          <animateTransform attributeName="transform" type="translate" values="0,0; 3%,2%; 0,0" dur="12s" repeatCount="indefinite"/>
        </circle>
        <circle cx="80%" cy="70%" r="25%" fill="url(#radial-glow)" opacity="0.4">
          <animateTransform attributeName="transform" type="translate" values="0,0; -2%,3%; 0,0" dur="15s" repeatCount="indefinite"/>
        </circle>
        
        <!-- 3D打印技术图纸 -->
        <g class="blueprint-elements">
          <!-- 技术图纸网格 -->
          <defs>
            <pattern id="grid" width="2" height="2" patternUnits="userSpaceOnUse">
              <path d="M 2 0 L 0 0 0 2" fill="none" stroke="#00a8ff" stroke-width="0.1" opacity="0.3"/>
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#grid)"/>
          
          <!-- 3D模型线框图 -->
          <g class="wireframe-model" opacity="0.6">
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 50 50;360 50 50"
              dur="20s"
              repeatCount="indefinite"/>
            <!-- 立方体线框 -->
            <path d="M20,20 L30,20 L30,30 L20,30 Z" fill="none" stroke="#00d4ff" stroke-width="0.3"/>
            <path d="M22,18 L32,18 L32,28 L22,28 Z" fill="none" stroke="#00d4ff" stroke-width="0.3"/>
            <path d="M20,20 L22,18 M30,20 L32,18 M30,30 L32,28 M20,30 L22,28" stroke="#00d4ff" stroke-width="0.3"/>
            
            <!-- 齿轮线框 -->
            <circle cx="70" cy="25" r="8" fill="none" stroke="#ff6b35" stroke-width="0.4"/>
            <path d="M70,17 L71,15 L69,15 Z M78,25 L80,26 L80,24 Z M70,33 L69,35 L71,35 Z M62,25 L60,24 L60,26 Z" 
                  fill="none" stroke="#ff6b35" stroke-width="0.3"/>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 70 25;360 70 25"
              dur="8s"
              repeatCount="indefinite"/>
          </g>
          
          <!-- CAD制图元素 -->
          <g class="cad-elements" opacity="0.4">
            <!-- 尺寸标注线 -->
            <line x1="15" y1="45" x2="35" y2="45" stroke="#00a8ff" stroke-width="0.2"/>
            <line x1="15" y1="43" x2="15" y2="47" stroke="#00a8ff" stroke-width="0.2"/>
            <line x1="35" y1="43" x2="35" y2="47" stroke="#00a8ff" stroke-width="0.2"/>
            <text x="25" y="43" fill="#00a8ff" font-size="1.5" text-anchor="middle" opacity="0.8">20mm</text>
            
            <!-- 角度标注 -->
            <path d="M60,60 A5,5 0 0,1 70,55" fill="none" stroke="#ff6b35" stroke-width="0.2"/>
            <text x="68" y="58" fill="#ff6b35" font-size="1.2" opacity="0.8">45°</text>
            
            <!-- 中心线 -->
            <line x1="10" y1="70" x2="90" y2="70" stroke="#00d4ff" stroke-width="0.15" 
                  stroke-dasharray="2,1" opacity="0.5"/>
            <line x1="50" y1="10" x2="50" y2="90" stroke="#00d4ff" stroke-width="0.15" 
                  stroke-dasharray="2,1" opacity="0.5"/>
          </g>
          
          <!-- 3D打印路径轨迹 -->
          <g class="print-path">
            <path d="M10,80 Q30,85 50,80 T90,85" fill="none" stroke="#4fc3f7" stroke-width="0.4" opacity="0.6">
              <animate attributeName="stroke-dasharray" values="0,100;50,50;100,0" dur="4s" repeatCount="indefinite"/>
              <animate attributeName="opacity" values="0.6;1;0.6" dur="4s" repeatCount="indefinite"/>
            </path>
            
            <!-- 打印层示意 -->
            <g opacity="0.5">
              <rect x="40" y="75" width="20" height="1" fill="#4fc3f7" opacity="0.8"/>
              <rect x="41" y="73" width="18" height="1" fill="#4fc3f7" opacity="0.7"/>
              <rect x="42" y="71" width="16" height="1" fill="#4fc3f7" opacity="0.6"/>
              <rect x="43" y="69" width="14" height="1" fill="#4fc3f7" opacity="0.5"/>
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0,0;0,-5;0,0"
                dur="6s"
                repeatCount="indefinite"/>
            </g>
          </g>
          
          <!-- 温度和参数指示器 -->
          <g class="parameters" opacity="0.6">
            <!-- 温度计图标 -->
            <rect x="85" y="15" width="2" height="10" rx="1" fill="#ff6b35"/>
            <circle cx="86" cy="27" r="2" fill="#ff6b35"/>
            <text x="89" y="20" fill="#ff6b35" font-size="1.5">210°C</text>
            
            <!-- 进度条 -->
            <rect x="10" y="15" width="20" height="2" fill="none" stroke="#00d4ff" stroke-width="0.2"/>
            <rect x="10" y="15" width="12" height="2" fill="#00d4ff" opacity="0.8">
              <animate attributeName="width" values="0;20;0" dur="10s" repeatCount="indefinite"/>
            </rect>
            <text x="32" y="17" fill="#00d4ff" font-size="1.2">60%</text>
          </g>
          
          <!-- 材料丝线轨迹 -->
          <g class="filament-path" opacity="0.5">
            <path d="M5,30 Q15,35 25,30 Q35,25 45,30 Q55,35 65,30" 
                  fill="none" stroke="#ff9f43" stroke-width="0.6">
              <animate attributeName="stroke-dasharray" values="0,80;40,40;80,0" dur="3s" repeatCount="indefinite"/>
            </path>
            <circle cx="5" cy="30" r="1" fill="#ff9f43">
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0,0;60,0;0,0"
                dur="3s"
                repeatCount="indefinite"/>
            </circle>
          </g>
          
          <!-- 技术符号和标记 -->
          <g class="tech-symbols" opacity="0.4">
            <!-- 表面粗糙度符号 -->
            <path d="M75,70 L78,67 L81,70" fill="none" stroke="#00a8ff" stroke-width="0.3"/>
            <text x="78" y="74" fill="#00a8ff" font-size="1" text-anchor="middle">Ra 3.2</text>
            
            <!-- 公差标注 -->
            <rect x="15" y="55" width="8" height="4" fill="none" stroke="#ff6b35" stroke-width="0.2"/>
            <text x="19" y="58" fill="#ff6b35" font-size="1" text-anchor="middle">±0.1</text>
            
            <!-- 材料标识 -->
            <circle cx="85" cy="45" r="3" fill="none" stroke="#4fc3f7" stroke-width="0.3"/>
            <text x="85" y="47" fill="#4fc3f7" font-size="1" text-anchor="middle">PLA</text>
          </g>
          
          <!-- 动态数据流 -->
          <g class="data-flow">
            <circle cx="20" cy="60" r="0.5" fill="#00d4ff" opacity="0.8">
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0,0;60,20;0,0"
                dur="5s"
                repeatCount="indefinite"/>
              <animate attributeName="opacity" values="0.8;0.2;0.8" dur="5s" repeatCount="indefinite"/>
            </circle>
            <circle cx="80" cy="30" r="0.5" fill="#ff6b35" opacity="0.8">
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0,0;-50,40;0,0"
                dur="7s"
                repeatCount="indefinite"/>
              <animate attributeName="opacity" values="0.8;0.2;0.8" dur="7s" repeatCount="indefinite"/>
            </circle>
          </g>
        </g>
        
        <!-- 3D打印器械和设备 -->
        <g class="equipment-elements">
          <!-- 大型3D打印机 -->
          <g transform="translate(60, 30)" class="main-printer">
            <!-- 打印机底座 -->
            <rect x="0" y="12" width="20" height="4" rx="0.5" fill="url(#printer-gradient)" opacity="0.6" />
            <!-- 打印机框架 -->
            <rect x="1" y="3" width="18" height="9" rx="0.3" fill="none" stroke="rgba(79,195,247,0.8)" stroke-width="0.2" />
            <!-- 垂直导轨 -->
            <line x1="2" y1="3" x2="2" y2="12" stroke="#4fc3f7" stroke-width="0.3" opacity="0.9" />
            <line x1="18" y1="3" x2="18" y2="12" stroke="#4fc3f7" stroke-width="0.3" opacity="0.9" />
            <!-- 打印头组件 -->
            <rect x="8" y="5" width="4" height="2" rx="0.2" fill="rgba(255,107,107,0.9)" />
            <rect x="9" y="6.5" width="2" height="0.8" rx="0.1" fill="#ff4757" opacity="0.8" />
            <!-- 打印平台 -->
            <rect x="3" y="10" width="14" height="0.8" rx="0.1" fill="rgba(255,255,255,0.8)" />
            <!-- 正在打印的模型 -->
            <circle cx="10" cy="9.5" r="1.5" fill="#67C23A" opacity="0.8">
              <animate attributeName="r" values="1; 1.8; 1" dur="4s" repeatCount="indefinite"/>
            </circle>
            <circle cx="10" cy="8.5" r="1" fill="#67C23A" opacity="0.6">
              <animate attributeName="r" values="0.5; 1.2; 0.5" dur="4s" begin="1s" repeatCount="indefinite"/>
            </circle>
            <!-- 打印头移动动画 -->
            <animateTransform attributeName="transform" type="translate" values="60,30; 62,29; 60,30" dur="8s" repeatCount="indefinite"/>
          </g>
          
          <!-- 切片软件界面模拟 -->
          <g transform="translate(25, 45)" opacity="0.4">
            <rect x="0" y="0" width="16" height="12" rx="0.5" fill="rgba(30,41,59,0.8)" stroke="#4fc3f7" stroke-width="0.1" />
            <!-- 软件标题栏 -->
            <rect x="0.5" y="0.5" width="15" height="1.5" rx="0.2" fill="rgba(79,195,247,0.2)" />
            <!-- 3D模型视口 -->
            <rect x="1" y="2.5" width="10" height="8" rx="0.2" fill="rgba(15,20,25,0.9)" stroke="#00bcd4" stroke-width="0.08" />
            <!-- 3D模型 -->
            <polygon points="6,4 8,6 6,8 4,6" fill="#4fc3f7" opacity="0.7">
              <animateTransform attributeName="transform" type="rotate" values="0 6 6; 360 6 6" dur="12s" repeatCount="indefinite"/>
            </polygon>
            <!-- 参数面板 -->
            <rect x="11.5" y="2.5" width="3.5" height="8" rx="0.2" fill="rgba(79,195,247,0.1)" stroke="#4fc3f7" stroke-width="0.05" />
            <line x1="12" y1="3.5" x2="14.5" y2="3.5" stroke="#4fc3f7" stroke-width="0.03" opacity="0.6" />
            <line x1="12" y1="4.5" x2="14.5" y2="4.5" stroke="#4fc3f7" stroke-width="0.03" opacity="0.6" />
            <line x1="12" y1="5.5" x2="14.5" y2="5.5" stroke="#4fc3f7" stroke-width="0.03" opacity="0.6" />
          </g>
          
          <!-- 材料供给系统 -->
          <g transform="translate(5, 50)" opacity="0.5">
            <!-- 材料卷轴 -->
            <circle cx="3" cy="3" r="2.5" fill="none" stroke="#00bcd4" stroke-width="0.15" opacity="0.8" />
            <circle cx="3" cy="3" r="1.5" fill="rgba(0,188,212,0.2)" />
            <!-- 供料管道 -->
            <path d="M5.5,3 Q8,2 10,3 Q12,4 14,3" fill="none" stroke="#4fc3f7" stroke-width="0.2" opacity="0.7" />
            <!-- 材料流动动画 -->
            <circle cx="6" cy="3" r="0.2" fill="#ff6b6b" opacity="0.9">
              <animateMotion dur="3s" repeatCount="indefinite">
                <mpath href="#filament-path"/>
              </animateMotion>
            </circle>
            <path id="filament-path" d="M5.5,3 Q8,2 10,3 Q12,4 14,3" fill="none" opacity="0"/>
            <animateTransform attributeName="transform" type="rotate" values="0 3 3; 360 3 3" dur="10s" repeatCount="indefinite"/>
          </g>
          
          <!-- 后处理设备 -->
          <g transform="translate(85, 55)" opacity="0.4">
            <!-- UV固化箱 -->
            <rect x="0" y="0" width="8" height="6" rx="0.3" fill="rgba(156,39,176,0.3)" stroke="#9c27b0" stroke-width="0.1" />
            <!-- UV灯 -->
            <rect x="1" y="0.5" width="6" height="0.5" rx="0.1" fill="#e91e63" opacity="0.8">
              <animate attributeName="opacity" values="0.5; 1; 0.5" dur="2s" repeatCount="indefinite"/>
            </rect>
            <!-- 固化中的模型 -->
            <rect x="3" y="3" width="2" height="2" rx="0.2" fill="#4fc3f7" opacity="0.6" />
          </g>
        </g>
        
        <!-- CAD/设计元素 -->
        <g class="cad-elements">
          <!-- 坐标系 -->
          <g transform="translate(90, 85)" opacity="0.6">
            <!-- X轴 -->
            <line x1="0" y1="3" x2="4" y2="3" stroke="#f44336" stroke-width="0.15" />
            <polygon points="4,3 3.5,2.8 3.5,3.2" fill="#f44336" />
            <text x="4.5" y="3.5" font-family="monospace" font-size="0.8" fill="#f44336">X</text>
            <!-- Y轴 -->
            <line x1="0" y1="3" x2="0" y2="-1" stroke="#4caf50" stroke-width="0.15" />
            <polygon points="0,-1 -0.2,-0.5 0.2,-0.5" fill="#4caf50" />
            <text x="-1" y="-0.5" font-family="monospace" font-size="0.8" fill="#4caf50">Y</text>
            <!-- Z轴 -->
            <line x1="0" y1="3" x2="-2" y2="1" stroke="#2196f3" stroke-width="0.15" />
            <polygon points="-2,1 -1.8,1.4 -1.6,0.8" fill="#2196f3" />
            <text x="-3" y="1" font-family="monospace" font-size="0.8" fill="#2196f3">Z</text>
          </g>
          
          <!-- 测量工具 -->
          <g transform="translate(45, 80)" opacity="0.5">
            <!-- 游标卡尺 -->
            <rect x="0" y="0" width="12" height="1" fill="rgba(158,158,158,0.8)" rx="0.1" />
            <rect x="1" y="-0.3" width="0.3" height="1.6" fill="#9e9e9e" />
            <rect x="8" y="-0.3" width="0.3" height="1.6" fill="#9e9e9e" />
            <!-- 刻度线 -->
            <line x1="2" y1="0.8" x2="2" y2="1.2" stroke="#616161" stroke-width="0.03" />
            <line x1="4" y1="0.8" x2="4" y2="1.2" stroke="#616161" stroke-width="0.03" />
            <line x1="6" y1="0.8" x2="6" y2="1.2" stroke="#616161" stroke-width="0.03" />
            <!-- 测量动画 -->
            <animateTransform attributeName="transform" type="translate" values="45,80; 47,80; 45,80" dur="6s" repeatCount="indefinite"/>
          </g>
        </g>
        
        <!-- 数据流和连接线 -->
        <g class="data-flow">
          <!-- 数据传输线1 -->
          <path d="M25,25 Q50,15 75,25" fill="none" stroke="rgba(79,195,247,0.4)" stroke-width="0.1">
            <animate attributeName="stroke-dasharray" values="0,20; 20,0; 0,20" dur="8s" repeatCount="indefinite"/>
          </path>
          <!-- 数据传输线2 -->
          <path d="M10,60 Q30,70 50,60 Q70,50 90,60" fill="none" stroke="rgba(0,188,212,0.3)" stroke-width="0.08">
            <animate attributeName="stroke-dasharray" values="0,30; 30,0; 0,30" dur="12s" repeatCount="indefinite"/>
          </path>
          <!-- 数据传输线3 -->
          <path d="M80,20 Q60,40 40,30 Q20,20 5,35" fill="none" stroke="rgba(79,195,247,0.2)" stroke-width="0.06">
            <animate attributeName="stroke-dasharray" values="0,25; 25,0; 0,25" dur="15s" repeatCount="indefinite"/>
          </path>
        </g>
        
        <!-- 层次打印动画 -->
        <g class="layer-animation" transform="translate(35, 20)" opacity="0.6">
          <rect x="0" y="8" width="8" height="0.3" fill="#4fc3f7" opacity="0.9">
            <animate attributeName="opacity" values="0; 1; 1; 0" dur="6s" repeatCount="indefinite"/>
          </rect>
          <rect x="0.5" y="7.5" width="7" height="0.3" fill="#4fc3f7" opacity="0.7">
            <animate attributeName="opacity" values="0; 1; 1; 0" dur="6s" begin="0.5s" repeatCount="indefinite"/>
          </rect>
          <rect x="1" y="7" width="6" height="0.3" fill="#4fc3f7" opacity="0.5">
            <animate attributeName="opacity" values="0; 1; 1; 0" dur="6s" begin="1s" repeatCount="indefinite"/>
          </rect>
          <rect x="1.5" y="6.5" width="5" height="0.3" fill="#4fc3f7" opacity="0.3">
            <animate attributeName="opacity" values="0; 1; 1; 0" dur="6s" begin="1.5s" repeatCount="indefinite"/>
          </rect>
        </g>
        
        <!-- 粒子效果 -->
        <g class="particles">
          <circle cx="25%" cy="15%" r="0.08%" fill="#4fc3f7" opacity="0.8">
            <animate attributeName="cy" values="15%; 85%; 15%" dur="8s" repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0; 1; 0" dur="8s" repeatCount="indefinite"/>
          </circle>
          <circle cx="65%" cy="85%" r="0.12%" fill="#00bcd4" opacity="0.6">
            <animate attributeName="cy" values="85%; 10%; 85%" dur="10s" repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0; 1; 0" dur="10s" repeatCount="indefinite"/>
          </circle>
          <circle cx="90%" cy="40%" r="0.06%" fill="#67C23A" opacity="0.7">
            <animate attributeName="cx" values="90%; 5%; 90%" dur="12s" repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0; 1; 0" dur="12s" repeatCount="indefinite"/>
          </circle>
          <circle cx="15%" cy="75%" r="0.1%" fill="#ff6b6b" opacity="0.5">
            <animate attributeName="cy" values="75%; 25%; 75%" dur="14s" repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0; 0.8; 0" dur="14s" repeatCount="indefinite"/>
          </circle>
        </g>
      </svg>
      
      <!-- 网格背景 -->
      <div class="grid-overlay"></div>
      
      <!-- 额外的CSS渐变层 -->
      <div class="gradient-overlay"></div>
    </div>

    <!-- 登录主体内容 -->
  <div class="login-main">
      <!-- 顶部logo区域 -->
      <div class="logo-section">
        <div class="logo-container">
          <div class="logo-icon">
            <!-- 3D打印logo SVG -->
            <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#4fc3f7" />
                  <stop offset="100%" stop-color="#29b6f6" />
                </linearGradient>
              </defs>
              <!-- 3D打印机外框 -->
              <rect x="8" y="15" width="44" height="35" rx="3" fill="none" stroke="url(#logo-gradient)" stroke-width="2" />
              <!-- 打印平台 -->
              <rect x="15" y="40" width="30" height="3" rx="1" fill="url(#logo-gradient)" />
              <!-- 打印头 -->
              <rect x="25" y="20" width="10" height="6" rx="1" fill="url(#logo-gradient)" />
              <!-- 正在打印的层 -->
              <rect x="20" y="35" width="20" height="2" rx="1" fill="#ff6b6b" opacity="0.8">
                <animate attributeName="opacity" values="0.5; 1; 0.5" dur="2s" repeatCount="indefinite"/>
              </rect>
              <rect x="22" y="32" width="16" height="2" rx="1" fill="#ff6b6b" opacity="0.6">
                <animate attributeName="opacity" values="0.3; 0.8; 0.3" dur="2s" begin="0.5s" repeatCount="indefinite"/>
              </rect>
              <rect x="24" y="29" width="12" height="2" rx="1" fill="#ff6b6b" opacity="0.4">
                <animate attributeName="opacity" values="0.2; 0.6; 0.2" dur="2s" begin="1s" repeatCount="indefinite"/>
              </rect>
            </svg>
          </div>
          <div class="logo-text">
            <h1 class="brand-name">3D Print Pro</h1>
            <p class="brand-subtitle">专业3D打印管理系统</p>
          </div>
        </div>
      </div>

      <!-- 登录表单区域 -->
      <div class="auth-section">
        <div class="auth-card">
          <div class="auth-header">
            <h2 class="auth-title">登录系统</h2>
            <p class="auth-subtitle">欢迎回到3D打印管理平台</p>
          </div>
          
          <div class="auth-form">
            <el-form ref="loginForm" :model="loginData" :rules="activeRules" @keyup.enter.native="loginClick">
              <el-form-item prop="email" class="form-item">
                <div class="input-wrapper">
                  <div class="input-icon">
                    <i class="el-icon-message"></i>
    </div>
              <el-input
                v-model="loginData.email"
                    placeholder="请输入邮箱地址"
                    size="large"
                    class="auth-input">
                  </el-input>
                </div>
            </el-form-item>
              
              <el-form-item prop="password" class="form-item">
                <div class="input-wrapper">
                  <div class="input-icon">
                    <i class="el-icon-lock"></i>
                  </div>
              <el-input
                :type="lockPassword"
                v-model="loginData.password"
                    placeholder="请输入密码"
                    size="large"
                    class="auth-input">
                    <i 
                      slot="suffix" 
                      :class="lockPassword === 'password' ? 'el-icon-view' : 'el-icon-hide'" 
                      @click="changeLockPassword"
                      class="password-toggle">
                    </i>
                  </el-input>
                </div>
              </el-form-item>
              
              <el-form-item v-if="otpEnabled" prop="authcode" class="form-item">
                <div class="input-wrapper">
                  <div class="input-icon">
                    <i class="el-icon-key"></i>
                  </div>
              <el-input
                :type="lockAuthCode"
                v-model="loginData.authcode"
                maxlength="6"
                    placeholder="请输入二次验证码"
                    size="large"
                    class="auth-input">
                    <i 
                      slot="suffix" 
                      :class="lockAuthCode === 'password' ? 'el-icon-view' : 'el-icon-hide'" 
                      @click="changeLockAuthCode"
                      class="password-toggle">
                    </i>
                  </el-input>
                </div>
            </el-form-item>
              
              <el-form-item class="form-item">
                <el-button 
                  class="login-button" 
                  type="primary" 
                  size="large"
                  @click="loginClick"
                  :loading="isLogging">
                  <span v-if="!isLogging">立即登录</span>
                  <span v-else>登录中...</span>
                </el-button>
            </el-form-item>
              
              <el-form-item class="form-item form-footer">
                <div class="form-extras">
                  <el-checkbox 
                    v-model="loginData.remember" 
                    class="remember-checkbox"
                    @change="handleRememberChange">
                    记住账号
                  </el-checkbox>
                  <div class="link-group">
                    <a href="#" class="forgot-link" @click.prevent="registerClick">
                      忘记密码？
                    </a>
                    <span class="link-separator">|</span>
                    <a href="#" class="clear-link" @click.prevent="clearRememberedCredentials">
                      清除保存
                    </a>
                  </div>
                </div>
            </el-form-item>
          </el-form>
          </div>
        </div>
      </div>

      <!-- 底部信息 -->
      <div class="footer-section">
        <div class="footer-content">
          <div class="feature-list">
            <div class="feature-item">
              <i class="el-icon-cpu"></i>
              <span>快递物流管理</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-monitor"></i>
              <span>丰富的内容管理</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-box"></i>
              <span>工艺材料管理</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-data-board"></i>
              <span>订单管理</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-data-analysis"></i>
              <span>数据分析报告</span>
            </div>

          </div>
          <p class="copyright">
            © 2024 3D Print Pro. 为专业3D打印而生
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import logo from "@/assets/logo.png";
import { encrypt } from '@/utils/utils'

export default {
  data() {
    return {
      lockPassword: "password",
      lockAuthCode: "password",
      isLogging: false,
      otpEnabled: false,
      loginData: {
        email: "",
        password: "",
        authcode: "",
        remember: false
      },
      logo,
      // 表单验证
      rules: {
        email: [
          { 
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, 
            required: true, 
            message: "请输入正确的邮箱地址", 
            trigger: "blur" 
          }
        ],
        password: [
          { 
            pattern: /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/, 
            required: true, 
            message: '密码必须6-20位且包含字母、数字和标点符号至少两种', 
            trigger: 'blur' 
          }
        ],
        authcode: [
          { 
            max: 6, 
            min: 6, 
            required: true, 
            message: "请输入6位二次验证码", 
            trigger: "blur" 
          }
        ],
      },
    };
  },
  computed: {
    activeRules() {
      const rules = { ...this.rules }
      if (!this.otpEnabled) {
        delete rules.authcode
      }
      return rules
    }
  },
  methods: {
    ...mapMutations(["handleUserInfo"]),
    registerClick() {
      this.$message.info("功能开发中，敬请期待");
    },
    changeLockPassword() {
      this.lockPassword = this.lockPassword === 'password' ? 'text' : 'password'
    },
    changeLockAuthCode() {
      this.lockAuthCode = this.lockAuthCode === 'password' ? 'text' : 'password'
    },
    Encrypt() {
      return encrypt(this.loginData.password)
    },
    // 点击登录按钮
    loginClick() {
      // 调用组件的数据验证方法
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("登录失败，请检查必填项数据！");
        }
      });
    },
    // 实际登录请求
    async formSubmit() {
      this.isLogging = true;
      try {
        let data = Object.assign({}, this.loginData);
        if (!this.otpEnabled) {
          delete data.authcode
        }
        let res = await this.$api.post("/service/user/login", data);
        
      if (!this.$apiSuccess(res)) {
        this.$message.error("登录失败，请联系管理员！");
        return;
      }
        
      if (res) {
        localStorage.setItem("user_info", JSON.stringify(res.data.detail));
        this.handleUserInfo(res.data.detail);
        localStorage.setItem('Authorization', res.data.detail.token);
        
        // 登录成功后保存记住的邮箱（不再存密码）
        this.saveRememberedCredentials();
        
        this.$message.success("登录成功！");
        this.go();
      } else {
        this.initRespErrMsgBoxMark();
        this.$message.error("登录失败，请联系管理员！");
        }
      } catch (error) {
        const c = Number(error && error.code)
        if (!Number.isFinite(c) || c === 0) {
          this.$message.error((error && error.message) || "网络连接失败，请稍后重试");
        }
      } finally {
        this.isLogging = false;
      }
    },
    // 路由跳转
    go(url = "/") {
      this.$router.push(url);
    },
    // 初始化响应错误弹窗标志
    initRespErrMsgBoxMark() {
      this.$store.commit("changeRespErrMsgBoxMark", false);
    },
    
    // 评审 F10：只记住邮箱，不再把管理员密码（哪怕 Base64）写入 localStorage。
    // 旧版 remembered_credentials 若含 password 字段，加载时一并清除。
    saveRememberedCredentials() {
      if (this.loginData.remember) {
        const credentials = {
          email: this.loginData.email,
          remember: true,
          timestamp: Date.now()
        };
        localStorage.setItem('remembered_credentials', JSON.stringify(credentials));
        this.$message.success("账号已保存（密码请使用浏览器密码管理器）");
      } else {
        this.clearRememberedCredentials();
      }
    },
    
    clearRememberedCredentials() {
      localStorage.removeItem('remembered_credentials');
    },
    
    loadRememberedCredentials() {
      try {
        const saved = localStorage.getItem('remembered_credentials');
        if (saved) {
          const credentials = JSON.parse(saved);
          // 迁移：发现旧版带 password 的条目立即重写为仅邮箱，清除明文风险
          if (credentials.password) {
            const cleaned = {
              email: credentials.email || '',
              remember: true,
              timestamp: credentials.timestamp || Date.now()
            };
            localStorage.setItem('remembered_credentials', JSON.stringify(cleaned));
            Object.assign(credentials, cleaned);
            delete credentials.password;
          }
          const isExpired = Date.now() - credentials.timestamp > 30 * 24 * 60 * 60 * 1000;
          if (!isExpired && credentials.remember) {
            this.loginData.email = credentials.email || '';
            this.loginData.password = '';
            this.loginData.remember = true;
          } else if (isExpired) {
            this.clearRememberedCredentials();
          }
        }
      } catch (error) {
        console.error('加载记住的账号失败:', error);
        this.clearRememberedCredentials();
      }
    },
    
    handleRememberChange(value) {
      this.loginData.remember = value;
      if (!value) {
        this.clearRememberedCredentials();
      }
    },
    async loadLoginConfig() {
      try {
        const config = await this.$api.getLoginConfig()
        this.otpEnabled = Boolean(config && config.otp_enabled)
      } catch (e) {
        this.otpEnabled = false
      }
    },
  },
  mounted() {
    this.initRespErrMsgBoxMark();
    this.loadLoginConfig();
    this.loadRememberedCredentials();
  },
};
</script>

<style lang="stylus" scoped>
.login-container
  min-height 100vh
  width 100vw
  position relative
  overflow hidden
  font-family 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif

// 背景容器 - 确保100%覆盖
.background-container
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  z-index 1
  
  .background-svg
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    object-fit cover
    
  .grid-overlay
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-image radial-gradient(circle at 25% 25%, rgba(255,255,255,0.02) 1px, transparent 1px), radial-gradient(circle at 75% 75%, rgba(255,255,255,0.02) 1px, transparent 1px)
    background-size 60px 60px, 40px 40px
    opacity 0.6
    
  .gradient-overlay
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background linear-gradient(45deg, rgba(102,126,234,0.1) 0%, rgba(118,75,162,0.1) 50%, rgba(240,147,251,0.1) 100%)
    opacity 0.8

// SVG动画元素
.floating-element
  animation float 8s ease-in-out infinite

@keyframes float
  0%, 100%
    transform translateY(0%)
  50%
    transform translateY(-2%)

// 主登录容器
.login-main
  position relative
  z-index 2
  min-height 100vh
  display flex
  flex-direction column
  justify-content center
  align-items center
  padding 20px
  backdrop-filter blur(1px)

// Logo区域
.logo-section
  margin-bottom 40px
  
  .logo-container
    display flex
    align-items center
    gap 16px
    text-align center
    
    .logo-icon
      filter drop-shadow(0 4px 8px rgba(0,0,0,0.1))
      
    .logo-text
      .brand-name
        font-size 32px
        font-weight 700
        color #fff
        margin 0 0 4px 0
        text-shadow 0 2px 4px rgba(0,0,0,0.3)
        
      .brand-subtitle
        font-size 14px
        color rgba(255,255,255,0.9)
        margin 0

// 认证区域
.auth-section
  .auth-card
    background rgba(255, 255, 255, 0.96)
    backdrop-filter blur(20px)
    border-radius 20px
    padding 40px
    width 400px
    box-shadow 0 25px 70px rgba(0,0,0,0.12), 0 10px 25px rgba(0,0,0,0.08)
    border 1px solid rgba(255,255,255,0.3)
    
    .auth-header
      text-align center
      margin-bottom 32px
      
      .auth-title
        font-size 28px
        font-weight 600
        color #2c3e50
        margin 0 0 8px 0
        
      .auth-subtitle
        font-size 14px
        color #7f8c8d
        margin 0

// 表单样式
.auth-form
  .form-item
    margin-bottom 24px
    
    &.form-footer
      margin-bottom 0
      
    .input-wrapper
      position relative
      display flex
      align-items center
      background #f8f9fa
      border-radius 12px
      border 2px solid transparent
      transition all 0.3s ease
      overflow hidden
      
      &:focus-within
        border-color #4fc3f7
        background #fff
        box-shadow 0 0 0 4px rgba(79,195,247,0.1)
        
      .input-icon
        display flex
        align-items center
        justify-content center
        width 48px
        height 48px
        color #7f8c8d
        font-size 18px
        background rgba(79,195,247,0.05)
        
      .auth-input
        flex 1
        
        /deep/ .el-input__inner
          border none
          background transparent
          height 48px
          line-height 48px
          font-size 16px
          color #2c3e50
          padding-left 16px
          
          &::placeholder
            color #bdc3c7
            
        /deep/ .el-input__suffix
          padding-right 16px
          
          .password-toggle
            cursor pointer
            color #7f8c8d
            font-size 16px
            transition color 0.3s ease
            
            &:hover
              color #4fc3f7

// 登录按钮
.login-button
  width 100%
  height 52px
  background linear-gradient(135deg, #4fc3f7 0%, #29b6f6 100%)
  border none
  border-radius 12px
  font-size 16px
  font-weight 600
  color #fff
  transition all 0.3s ease
  box-shadow 0 4px 15px rgba(79,195,247,0.3)
  position relative
  overflow hidden
  
  &::before
    content ''
    position absolute
    top 0
    left -100%
    width 100%
    height 100%
    background linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)
    transition left 0.5s ease
    
  &:hover
    transform translateY(-2px)
    box-shadow 0 6px 20px rgba(79,195,247,0.4)
    background linear-gradient(135deg, #29b6f6 0%, #0288d1 100%)
    
    &::before
      left 100%
    
  &:active
    transform translateY(0)

// 表单底部
.form-extras
  display flex
  justify-content space-between
  align-items center
  
  .remember-checkbox
    /deep/ .el-checkbox__label
      color #7f8c8d
      font-size 14px
      
  .link-group
    display flex
    align-items center
    gap 8px
    
    .forgot-link, .clear-link
      color #4fc3f7
      text-decoration none
      font-size 14px
      transition color 0.3s ease
      
      &:hover
        color #29b6f6
        
    .link-separator
      color #bdc3c7
      font-size 12px

// 底部区域
.footer-section
  margin-top 60px
  
  .footer-content
    text-align center
    
    .feature-list
      display flex
      justify-content center
      gap 32px
      margin-bottom 24px
      flex-wrap wrap
      
      .feature-item
        display flex
        flex-direction column
        align-items center
        gap 8px
        color rgba(255,255,255,0.9)
        font-size 12px
        transition all 0.3s ease
        
        &:hover
          transform translateY(-2px)
          color rgba(255,255,255,1)
        
        i
          font-size 24px
          color #4fc3f7
          margin-bottom 4px
          filter drop-shadow(0 2px 4px rgba(0,0,0,0.1))
          
    .copyright
      color rgba(255,255,255,0.7)
      font-size 12px
      margin 0

// 响应式设计
@media (max-width: 768px)
  .login-main
    padding 16px
    
  .logo-section
    margin-bottom 32px
    
    .logo-container
      flex-direction column
      gap 12px
      
      .logo-text
        .brand-name
          font-size 28px
          
  .auth-section
    .auth-card
      width 100%
      max-width 360px
      padding 32px 24px
      
  .footer-section
    margin-top 40px
    
    .footer-content
      .feature-list
        gap 20px
        
        .feature-item
          font-size 11px
          
          i
            font-size 20px

@media (max-width: 480px)
  .logo-section
    .logo-container
      .logo-text
        .brand-name
          font-size 24px
          
  .auth-section
    .auth-card
      padding 24px 20px
      
      .auth-header
        .auth-title
          font-size 24px

// 加载动画
@keyframes pulse
  0%
    opacity 0.8
  50%
    opacity 1
  100%
    opacity 0.8

.loading
  animation pulse 1.5s ease-in-out infinite

// 确保SVG在所有设备上正确显示
@media (min-aspect-ratio: 16/9)
  .background-svg
    height 100vh
    width 177.78vh // 16:9 比例

@media (max-aspect-ratio: 16/9)
  .background-svg
    width 100vw
    height 56.25vw // 16:9 比例
</style>
